/**
 * Copyright (C) 2018 Egylis,
 * Siège social, 46 rue René Clair, 75892 PARIS cedex 18 - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 06/12/18.
 *
 * Version : Generator 2.0.9
 */

import {MOEntityMeta} from '../metaEntity/';
import {MetaColumn} from '../defEntity/';
import {MOEntity} from '../entity/';

/**
 * MoPersistenceEntity
 */
export class MoPersistenceEntity<T extends MOEntity> {
    /**
     * Class.
     */
    private _classMetaEntity: MOEntityMeta<T>;
    /**
     * Name.
     */
    private _table: string;
    /**
     * List of columns
     */
    private _columns: Array<MetaColumn>;
    /**
     * Property to columns for Entity
     */
    private _prop2Column: { [key: string]: MetaColumn; };
    /**
     * column name to columns for Entity
     */
    private _db2Column: { [key: string]: MetaColumn; };

    /**
     * Construtor
     * @param classEntity class Entity
     */
    constructor(classEntity: MOEntityMeta<T>) {
        this._classMetaEntity = classEntity;
        this._table = classEntity.tableName;
        this._db2Column = {};
        this._prop2Column = {};
        this._columns = [];
        for (const key of Object.keys(classEntity.columns)) {
            const column: MetaColumn = classEntity.columns[key];
            this._prop2Column[key] = column;
            this._db2Column[column.propertyName] = column;
            this._columns.push(column);
        }
    }

    /**
     * Getter.
     */
    public get table(): string {
        return this._table;
    }

    /**
     * Getter.
     */
    public get classMetaEntity(): MOEntityMeta<T> {
        return this._classMetaEntity;
    }

    /**
     * Getter.
     */
    public get columns(): Array<MetaColumn> {
        return this._columns;
    }

    /**
     * Getter.
     */
    public get prop2Column(): { [p: string]: MetaColumn } {
        return this._prop2Column;
    }

    /**
     * Getter.
     */
    public get db2Column(): { [p: string]: MetaColumn } {
        return this._db2Column;
    }
}
